import { render, staticRenderFns } from "./refComponentsList.vue?vue&type=template&id=60763d8e"
import script from "./refComponentsList.vue?vue&type=script&lang=js"
export * from "./refComponentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports